var installedModules = {};
__webpack_require__.consumesLoadingData.moduleIdToConsumeDataMapping = {
	29434: {
		fallback: () => (() => (__webpack_require__(96540))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "18.2.0",
		strictVersion: false,
		eager: true,
		layer: undefined,
		shareKey: "react",
	},
	27078: {
		fallback: () => (() => (__webpack_require__(40961))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "18.2.0",
		strictVersion: false,
		eager: true,
		layer: undefined,
		shareKey: "react-dom",
	},
	38172: {
		fallback: () => (() => (__webpack_require__(22451))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^5.9.4",
		strictVersion: false,
		eager: true,
		layer: undefined,
		shareKey: "mobx",
	},
	98486: {
		fallback: () => (() => (__webpack_require__(6359))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^5.4.3",
		strictVersion: false,
		eager: true,
		layer: undefined,
		shareKey: "mobx-react",
	},
	34452: {
		fallback: () => (() => (__webpack_require__(17437))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^11.14.0",
		strictVersion: false,
		eager: true,
		layer: undefined,
		shareKey: "@emotion/react",
	},
	58704: {
		fallback: () => (() => (__webpack_require__(34814))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "3.0.0",
		strictVersion: false,
		eager: true,
		layer: undefined,
		shareKey: "@nuskin/foundation-ui-components",
	},
	3329: {
		fallback: () => (() => (__webpack_require__(90410))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "1.8.0",
		strictVersion: false,
		eager: true,
		layer: undefined,
		shareKey: "@nuskin/foundation-theme",
	},
	6408: {
		fallback: () => (() => (__webpack_require__(83296))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^11.14.0",
		strictVersion: false,
		eager: true,
		layer: undefined,
		shareKey: "@emotion/styled",
	},
	21657: {
		fallback: () => (() => (__webpack_require__(23224))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^1.9.5",
		strictVersion: false,
		eager: true,
		layer: undefined,
		shareKey: "pubsub-js",
	},
	47338: {
		fallback: () => (() => (__webpack_require__(84734))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^3.0.2",
		strictVersion: false,
		eager: true,
		layer: undefined,
		shareKey: "@nuskin/configuration-sdk",
	},
	48084: {
		fallback: () => (() => (__webpack_require__(50733))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^1.9.5",
		strictVersion: false,
		eager: true,
		layer: undefined,
		shareKey: "pubsub-js",
	},
	25132: {
		fallback: () => (() => (__webpack_require__(94575))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^1.9.5",
		strictVersion: false,
		eager: true,
		layer: undefined,
		shareKey: "pubsub-js",
	},
	72465: {
		fallback: () => (() => (__webpack_require__(14653))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^3.0.2",
		strictVersion: false,
		eager: true,
		layer: undefined,
		shareKey: "@nuskin/configuration-sdk",
	},
	75490: {
		fallback: () => (() => (__webpack_require__(8140))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "1.4.3",
		strictVersion: false,
		eager: true,
		layer: undefined,
		shareKey: "@nuskin/react-mysite-elements",
	}
};
var moduleToHandlerMapping = {};
__webpack_require__.consumesLoadingData.initialConsumes = [29434,27078,38172,98486,34452,58704,3329,6408,21657,47338,48084];
__webpack_require__.federation.installInitialConsumes = () => (__webpack_require__.federation.bundlerRuntime.installInitialConsumes({
	initialConsumes: __webpack_require__.consumesLoadingData.initialConsumes,
	installedModules:installedModules,
	moduleToHandlerMapping,
	webpackRequire: __webpack_require__
}))
__webpack_require__.consumesLoadingData.chunkMapping = {
	"12903": [
		72465,
		75490
	],
	"38258": [
		25132
	],
	"38792": [
		29434,
		27078,
		38172,
		98486,
		34452,
		58704,
		3329,
		6408,
		21657,
		47338,
		48084
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: __webpack_require__.consumesLoadingData.chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}